import React from "react";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import IconEmail from "../../atoms/Icons/IconEmail";
import SocialMediaIcons from "../../molecules/Icons/SocialMediaIcons";
import IconChevronRight from "../../atoms/Icons/IconChevronRight";

const DefaultDepartmentPeopleList = ({title, fieldDepartmentPeoples, handleShowDetails}) => {
  return (
    <div className="container general-container">
      {Boolean(title) && <h2 className="dept-people-header">{title}</h2>}
      <div className="row">
      {fieldDepartmentPeoples?.map((item, index) => (
        <div
          key={index}
          className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-5"
        >
          <div className="dept-people-card">
            {item?.relationships?.field_department_people_icon ? (
              <>
                <GatsbyImage
                  className="dept-people-card-img"
                  image={getImage(
                    item?.relationships?.field_department_people_icon
                      ?.gatsbyImage
                  )}
                  alt={title}
                />
              </>
            ) : (
              <div className="dept-image-wrapper dept-image-wrapper-default dept-people-card-img bg-clr-lightgrey ">
                <img src="/images/avatar.png" alt="avatar" />
              </div>
            )}
            <div className="dept-people-card-info">
              <h3 className="dept-people-card-title">
                {item?.field_department_people_name}
              </h3>
              <p className="dept-people-card-subtitle">
                {item?.field_department_people_title}
              </p>
            </div>

            <div className="dept-people-card-footer">
              <div className="dept-people-card-social-icons">
                {item?.field_department_people_email && (
                  <a
                    aria-label="email"
                    role="button"
                    tabIndex={0}
                    rel="noopener noreferrer"
                    className="dept-people-card-social-icons"
                    href={`mailto:${item?.field_department_people_email}`}
                    target="_blank"
                  >
                    <IconEmail color="secondary" />
                  </a>
                )}

                <SocialMediaIcons
                  color="secondary"
                  variant="dept-people-card-social-icons"
                  platformValues={
                    item?.field_social_profile_links?.platform_values
                  }
                />
              </div>
              <span
                role="button"
                tabIndex={0}
                className="dept-people-btn-icon"
                onClick={(ev) => handleShowDetails(ev, item)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === "Space") {
                    handleShowDetails(event, item);
                  }
                }}
              >
                    <span>See Bio</span>
                    <IconChevronRight color="secondary" noHover />
                  </span>
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  )
}

export default DefaultDepartmentPeopleList;